import { theme } from '@/themes/main';

export const spacing = (multiplier: number) => `${theme.spacing.base * multiplier}px`;
